import actionTypes from 'Redux/constants';

export function openCreateReviewModal(selectedReview = null) {
  return dispatch => {
    dispatch({
      type: actionTypes.createReview.openCreateReviewModal,
      payload: {
        isOpen: true,
        selectedReview,
      },
    });
  };
}

export function closeCreateReviewModal() {
  return dispatch => {
    dispatch({
      type: actionTypes.createReview.closeCreateReviewModal,
      payload: {
        isOpen: false,
        selectedReview: null,
      },
    });
  };
}

export function setSelectedReview(reviewData) {
  return dispatch => {
    dispatch({
      type: actionTypes.createReview.setSelectedReview,
      payload: reviewData,
    });
  };
}

export function clearSelectedReview() {
  return dispatch => {
    dispatch({
      type: actionTypes.createReview.clearSelectedReview,
      payload: null,
    });
  };
}
